import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-vendor',
  templateUrl: './modify-vendor.component.html',
  styleUrls: ['./modify-vendor.component.css']
})
export class ModifyVendorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
